<div class="page-container">
  <div class="header-section">
    <h1>Article Sizes</h1>
    <button class="btn-primary" (click)="createArticleSize()">
      <span class="material-icons">add</span>
      New Article Size
    </button>
  </div>

  <div class="filter-section">
    <div class="search-box">
      <span class="material-icons search-icon">search</span>
      <input pInputText [(ngModel)]="searchText" (input)="onSearchChange()" placeholder="Search by name..."
        class="search-input" />
      <button *ngIf="searchText" class="clear-search-btn" (click)="clearSearch()">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="filter-info">
      <span class="result-count">{{ gridView.total }} Article Sizes found</span>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner styleClass="labtech-spinner" ariaLabel="Loading"></p-progressSpinner>
    <p>Loading article sizes...</p>
  </div>

  <div class="cards-grid" *ngIf="!loading">
    <div class="card" *ngFor="let articleSize of gridView.data" [@cardAnimation]>
      <div class="card-header">
        <div class="card-icon">
          <span class="material-icons">straighten</span>
        </div>
        <div class="card-title-section">
          <h3 class="card-title">{{ articleSize.name || 'Unnamed Article Size' }}</h3>
        </div>
        <div class="overview-card-actions">
          <button type="button" class="card-icon-btn" (click)="toggleActionMenu(articleSize.databaseId, $event)"
            [attr.aria-expanded]="isActionMenuOpen(articleSize.databaseId)" title="Article size actions">
            <span class="material-icons">more_vert</span>
          </button>
          <div class="card-action-menu" *ngIf="isActionMenuOpen(articleSize.databaseId)" (click)="$event.stopPropagation()">
            <button type="button" class="menu-action" (click)="closeActionMenu(); editArticleSize(articleSize)">
              <span class="material-icons">edit</span>
              Edit
            </button>
            <button *ngIf="articleSize.canBeDeleted" type="button" class="menu-action menu-action-danger"
              (click)="closeActionMenu(); deleteArticleSize(articleSize)">
              <span class="material-icons">delete</span>
              Delete
            </button>
            <button *ngIf="!articleSize.canBeDeleted" type="button" class="menu-action menu-action-disabled" disabled>
              <span class="material-icons">info</span>
              Used in Inspection
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="info-row">
          <span class="material-icons info-icon">inventory</span>
          <div class="info-content">
            <span class="info-label">Internal Size</span>
            <div class="status-badges">
              <span class="status-badge" [class.active]="articleSize.isInternalSize">
                <span class="material-icons">{{ articleSize.isInternalSize ? 'check_circle' : 'cancel' }}</span>
                Internal Size
              </span>
            </div>
          </div>
        </div>
        <div class="info-row">
          <span class="material-icons info-icon">inventory</span>
          <div class="info-content">
            <span class="info-label">Master Data</span>
            <div class="status-badges">
              <span class="status-badge" [class.active]="articleSize.isMasterData">
                <span class="material-icons">{{ articleSize.isMasterData ? 'check_circle' : 'cancel' }}</span>
                Master Data
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-empty-state
    *ngIf="!loading && gridView.data.length === 0"
    icon="search_off"
    headline="No article sizes found"
    [subline]="searchText ? 'Try adjusting your search criteria' : 'Click &quot;New Article Size&quot; to create your first article size'">
  </app-empty-state>

  <div class="pagination-section" *ngIf="!loading && gridView.total > 0">
    <p-paginator [totalRecords]="gridView.total" [rows]="state.take ?? 12" [first]="state.skip ?? 0" [rowsPerPageOptions]="[12, 24, 48]" (onPageChange)="pageChange($event)"></p-paginator>
    <span class="result-count pagination-range">{{ footerRangeLabel }}</span>
  </div>

  <ng-container *ngIf="deleteDialog">
    <p-dialog [modal]="true" [visible]="true" header="Delete Article Size" (onHide)="toggleDeleteDialog()" [style]="{ width: '450px' }">
      <div class="dialog-content">
        <p>Are you sure you want to delete Article Size <strong>{{ selectedArticleSize?.name }}</strong>?</p>
        <p class="dialog-warning-text">This action cannot be undone.</p>
      </div>
      <ng-template pTemplate="footer">
        <button class="btn-secondary" (click)="toggleDeleteDialog()">Cancel</button>
        <button class="btn-primary" (click)="confirmDelete()">
          <span class="material-icons">delete</span>
          Delete
        </button>
      </ng-template>
    </p-dialog>
  </ng-container>

  <ng-container *ngIf="editDialog">
    <p-dialog [modal]="true" [visible]="true" header="Edit Article Size" (onHide)="toggleEditDialog()" [style]="{ width: '500px' }">
      <div class="edit-form" *ngIf="selectedArticleSize">
        <div class="form-row">
          <label class="form-label">Article Size Name</label>
            <input pInputText [(ngModel)]="selectedArticleSize.name" placeholder="Enter name..." />
          
        </div>
        <div class="form-row checkbox-row">
          <label>
            <input type="checkbox" [(ngModel)]="selectedArticleSize.isInternalSize" />
            <span>Internal Size</span>
          </label>
        </div>
        <div class="form-row checkbox-row">
          <label>
            <input type="checkbox" [(ngModel)]="selectedArticleSize.isMasterData" />
            <span>Master Data</span>
          </label>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <button class="btn-secondary" (click)="toggleEditDialog()">Cancel</button>
        <button class="btn-primary" (click)="saveArticleSize()">Save</button>
      </ng-template>
    </p-dialog>
  </ng-container>
</div>
